
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'
import PdfContent from '@/components/organisms/PdfContent.vue'
import TopicalLoading from '@/components/organisms/TopicalLoading.vue'

/**
 * PDF表示ページのフォーマット
 */
@Component({
  components: {
    ImageBase,
    ButtonOptional,
    PdfContent,
    TopicalLoading,
  },
})
export default class PdfViewerTemplate extends Vue {
  /** PDFデータ */
  @Prop()
  private pdfBlob!: Blob

  /** 表示待ち時間(秒数) */
  @Prop({ default: 5 })
  private waitSec!: number

  /**
   * 表示待ちタイムアウト時イベント
   *   非対応ブラウザなどで発生する可能性があるため、ダウンロードの案内などを表示させる
   */
  @Prop()
  private eventTimeout?: () => void

  /** ダウンロードイベント */
  @Prop()
  private eventDownload!: () => void

  /** 読み込み完了フラグ */
  private isCompleted = false

  /** PDFのArrayBufferデータ */
  private pdfData: ArrayBuffer | null = null

  /**
   * 読み込み時処理
   */
  private async mounted(): Promise<void> {
    // BlobデータからArrayBufferデータを取得(nullが返った場合もタイムアウト時の挙動がキャッチしてくれる)
    this.pdfData = await this.pdfBlob.arrayBuffer()

    // 表示待ち時間が経過した際の処理を設定
    setTimeout(this.timeout, this.waitSec * 1000)
  }

  /**
   * 待ち時間経過時処理
   */
  private timeout(): void {
    // 読み込み完了済みの場合は終了
    if (this.isCompleted) {
      return
    }

    // イベント未設定の場合は終了
    if (!this.eventTimeout) {
      return
    }

    // タイムアウト処理実行
    this.eventTimeout()
  }

  /**
   * PDFの表示完了後処理
   */
  private afterRendering(): void {
    this.isCompleted = true
  }

  /**
   * PDFの表示失敗時処理(通常発生しない)
   */
  private failed(): void {
    alert('PDFの表示に失敗しました。ダウンロードをお試しください。')
  }
}
